module.exports = __webpack_public_path__ + "img/userHeadImg_Default.d9523e51.png";